// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '@coa/app/core/services/config.service';
import { Group, GroupsResponse } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/models/groups.response';

@Injectable({
  providedIn: 'root',
})
export class AddToGroupService {
  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  getGroups(clientId: number): Observable<GroupsResponse> {
    const url = `${ this.configService.getConfig().analyticsApi }/dynamic-groups/all`;
    const params = new HttpParams()
      .set('clientId', clientId.toString());

    return this.httpClient.get<GroupsResponse>(url, {params});
  }

  addToGroup(clientId: number, groupId: string, selections: number[], version: number): Observable<Group> {
    const url = `${ this.configService.getConfig().analyticsApi }/dynamic-groups/${ groupId }`;
    const body = {
      clientId: +clientId,
      locationUnitIdsToAdd: selections.map(id => +id),
      version: +version,
    };
    return this.httpClient.put<Group>(url, body);
  }
}
